import { render, staticRenderFns } from "./EditIncidenciaPage.vue?vue&type=template&id=78bb8016"
import script from "./EditIncidenciaPage.vue?vue&type=script&lang=js"
export * from "./EditIncidenciaPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports